import React, {FunctionComponent, useEffect, useState} from "react";
import "./LoadingBase.scss";

export type LoadingGifProps = {
  errorText?: JSX.Element,
  passedInText?: JSX.Element,
  overrideLoadingText?: string,
  fullScreen?: boolean,
  style?: React.CSSProperties,
}

type LoadingBaseProps = LoadingGifProps & {
  loadingAsset: JSX.Element,
}

const LoadingBase: FunctionComponent<LoadingBaseProps> = (loadingGifProps) => {
  const {
    loadingAsset,
    errorText,
    passedInText,
    overrideLoadingText,
    fullScreen,
    style,
  } = loadingGifProps;
  const [loadingText, setLoadingText] = useState<string>(overrideLoadingText || "Loading...");

  useEffect(() => {

  }, []);

  function getLoadingText() {
    if (errorText) {
      return <div className="center-text padding-top"
                  style={{marginBottom: "auto"}}>
        {errorText}
      </div>
    } else if (passedInText) {
      return <div className="center-text padding-top"
                  style={{marginBottom: "auto"}}>
        {passedInText}
      </div>
    } else {
      return <h5 className="loading-text center-text max-small-text-width none-selectable">{loadingText}</h5>;
    }
  }

  const baseClazzName = "loading-container flex-col"

  return (
    <div className={fullScreen === undefined || fullScreen ? "full-screen-loading-container " + baseClazzName : baseClazzName} style={style}>
      {loadingAsset}
      {getLoadingText()}
    </div>
  )
}

export default LoadingBase;
